
const defaultBoxes = [];
const favoriteBoxesList = (state = defaultBoxes, action) => {
  switch (action.type) {
    case 'EPIK_BOXES_SUCCESS_BY_FAVORITES_CLEAR':
      return defaultBoxes;
    case 'EPIK_BOXES_SUCCESS_BY_FAVORITES':
      return action.favBoxesList;
    default:
      return state;
  }
};

export default favoriteBoxesList;
